import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const rootId = 'root'
const getContainer = () => {
  let el = document.getElementById(rootId)
  if (!el) {
    el = document.createElement('div')
    el.id = rootId
    document.body.appendChild(el)
  }
  return el
}

async function bootstrap() {
  createRoot(getContainer()).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

bootstrap()
